/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FC, useState } from "react";
import { useTaskRegisterDataContext } from "context/TaskRegisterDataProvider";

interface MaterialSelectorProps {
  label?: string;
  disabled?: boolean;
  materialId?: number;
  onSelected?: (materialId: number) => void;
}
export const MaterialSelector: FC<MaterialSelectorProps> = ({
  label,
  disabled,
  materialId,
  onSelected,
}) => {
  const { materials } = useTaskRegisterDataContext();
  const [selectedMaterialId, setSelectedMaterialId] = useState(materialId);
  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        sx={{ width: "100%", backgroundColor: "white" }}
        size="small"
        label={label}
        value={selectedMaterialId?.toString() ?? ""}
        disabled={disabled}
        onChange={(e) => {
          setSelectedMaterialId(Number(e.target.value));
          onSelected?.(Number(e.target.value));
        }}
      >
        {materials?.map((m) => (
          <MenuItem key={m.id} value={m.type}>
            {m.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
